import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as authService from "../../services/auth/auth-service";
import Auth from "../../utils/auth";
import { ROLE, defaultListItem, ddUserType } from "../../common/const";
import * as Loader from "../../common/common";
import DropDown from "../../components/form-controls/dropdown";
import { withNavigation } from "../../common/hocs";

class Login extends Component {
  // constructor(props) {
  //   super(props);
  //   this.onChange = this.onChange.bind(this);
  //   this.onSubmit = this.onSubmit.bind(this);
  //   this.onKeyPress = this.onKeyPress.bind(this);
  //   this.reloadCaptcha = this.reloadCaptcha.bind(this);
  //   this.navigate = useNavigate();
  // }
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.reloadCaptcha = this.reloadCaptcha.bind(this);
  }
  state = {
    login: {
      username: "",
      password: "",
      userType: "",
    },
    validationMessage: {
      usernameValidation: "",
      passwordValidation: "",
      recaptchaValidation: "",
      userTypeValidation: "",
    },
    error: "",
    isVerified: false,
    captchaValue: "",
    loadCaptcha: "",
  };

  onChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    var validaitonMessage = Object.assign({}, this.state.validationMessage);
    if (name === "username") {
      if (value === "") {
        validaitonMessage.usernameValidation = "Please enter the User Name";
      } else {
        validaitonMessage.usernameValidation = "";
      }
    }
    if (name === "password") {
      if (value === "") {
        validaitonMessage.passwordValidation = "Please enter the Password";
      } else {
        validaitonMessage.passwordValidation = "";
      }
    }

    this.setState({
      validationMessage: validaitonMessage,
    });

    if (name == "captchaValue") {
      this.setState({
        ...this.state,
        [name]: value,
      });
    } else {
      this.setState({
        login: {
          ...this.state.login,
          [name]: value,
        },
      });
    }
  }
  onKeyPress(e) {
    if (e.which === 13) {
      this.onSubmit();
    }
  }

  componentDidMount() {
    this.reloadCaptcha();
  }

  async reloadCaptcha() {
    try {
      const response = await fetch("/api/auth/captcha");
      const data = await response.json();
      this.setState({
        loadCaptcha: `${data.question} = ?`,
      });
    } catch (err) {
      console.log("Something went wrong", err);
    }
  }

  async onSubmit() {
    Loader.showLoader();
    let { username, password, userType } = this.state.login;
    let validationMessage = Object.assign({}, this.state.validationMessage);
    let isValidated = false;
    let captcha = "";
    captcha = this.state.captchaValue;
    // if (!this.state.isVerified) {
    //   validationMessage.recaptchaValidation =
    //     "Please verify that you are a human";
    //   isValidated = true;
    // } else {
    //   validationMessage.recaptchaValidation = "";
    // }
    if (!userType) {
      validationMessage.userTypeValidation = "Please select User Type";
      isValidated = true;
    } else {
      validationMessage.userTypeValidation = "";
    }
    if (username !== undefined) {
      if (username === "") {
        validationMessage.usernameValidation = "Please enter the User Name";
        isValidated = true;
      } else {
        validationMessage.usernameValidation = "";
      }
    }
    if (password !== undefined) {
      if (password === "") {
        validationMessage.passwordValidation = "Please enter the Password";
        isValidated = true;
      } else {
        validationMessage.passwordValidation = "";
      }
    }
    if (!isValidated) {
      let loginData = {};
      loginData.username = userType + username;
      loginData.password = password;
      loginData.captcha = captcha;
      let { response, err } = await authService.login(loginData);
      Loader.hideLoader();
      if (err) {
        this.setState({
          error: err,
          isVerified: false,
        });
      } else if (response.data && response.data.err) {
        this.setState({
          error: response.data.err,
          isVerified: false,
        });
      } else {
        let d = response.data;
        Auth.set("token", response.headers.token);
        Auth.set("userId", d.userId);
        Auth.set("role", d.role);
        Auth.set("email", d.email);
        Auth.set("userType", d.userType);
        Auth.set("access", d.access);
        Auth.set("name", d.name);
        Auth.set("infoId", d.infoId);
        if (d.userType === "InternalUser") {
          if (d.role === ROLE.itAdmin) {
            //this.props.navigate("/AdminCreateUser");
            window.location.href = "/AdminCreateUser";
          } else {
            //this.props.navigate("/kycs");
            window.location.href = "/kycs";
          }
        } else {
          //this.props.navigate("/kyc");
          window.location.href = "/kyc";
        }
      }
    } else {
      Loader.hideLoader();

      this.setState({
        validationMessage: validationMessage,
        isVerified: false,
      });
    }
    this.reloadCaptcha();
    this.setState({
      captchaValue: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="app flex-row align-items-center">
          <div className="container">
            <div style={{ textAlign: "center" }}>
              <img src="/images/logo.jpg" width="201" height="40" alt="logo" />
            </div>
            <p></p>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card-group rounded-0">
                  <div className="card p-3 rounded-0">
                    <div className="card-body">
                      <form onKeyPress={this.onKeyPress}>
                        <h1>Login</h1>
                        <p className="text-muted">Sign In to your account</p>
                        {this.state.error ? (
                          <p className="text" style={{ color: "red" }}>
                            {this.state.error}
                          </p>
                        ) : null}

                        <div>
                          <DropDown
                            label="User Type"
                            name="userType"
                            required="true"
                            value={this.state.login.userType || ""}
                            error={
                              this.state.validationMessage.userTypeValidation
                            }
                            onChange={this.onChange}
                            defaultItem={defaultListItem}
                            list={ddUserType}
                            valProp="value"
                            textProp="name"
                          />
                        </div>

                        <label>User Name</label>
                        <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="fa fa-envelope"></i>
                            </span>
                          </div>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Email"
                            name="username"
                            onChange={this.onChange}
                            autoComplete="off"
                          />
                        </div>
                        <div className="error-msg">
                          {this.state.validationMessage.usernameValidation}
                        </div>
                        <label>Password</label>
                        <div className="input-group mb-4">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="fa fa-lock"></i>
                            </span>
                          </div>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="Password"
                            name="password"
                            onChange={this.onChange}
                            onKeyPress={this.onKeyPress}
                            autoComplete="off"
                          />
                        </div>
                        <div className="error-msg">
                          {this.state.validationMessage.passwordValidation}
                        </div>
                        <div className="input-group">
                          <span onClick={this.reloadCaptcha}>
                            <i className="fas fa-sync mt-5 ml-2"></i>
                          </span>

                          <span className="form-control mt-4" style={{ border: 'none' }}>
                            {this.state.loadCaptcha}
                          </span>

                          <input
                            className="form-control mt-4"
                            type="text"
                            value={this.state.captchaValue}
                            placeholder="Answer"
                            name="captchaValue"
                            onChange={this.onChange}
                            autoComplete="off"
                          />
                        </div>
                        <div className="error-msg">
                          {this.state.validationMessage.recaptchaValidation}
                        </div>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                          <div className="col-6">
                            <button
                              className="btn btn-primary px-4"
                              type="button"
                              onClick={this.onSubmit}
                            >
                              Login
                            </button>
                          </div>
                          <div className="col-6 text-right">
                            <Link to="/ForgetPassword">
                              <button
                                className="btn btn-link px-0"
                                type="button"
                              >
                                Forgot password?
                              </button>
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="card text-white bg-primary py-5 rounded-0">
                    {/* <div className="card text-white bg-primary py-5 d-md-down-none" style={{width:"44%"}}> */}
                    <div className="card-body text-center">
                      <div>
                        <h2>Sign up</h2>
                        <p>&nbsp;</p>
                        <Link to="/Register/Customer">
                          <button
                            className="btn btn-primary active mt-3"
                            type="button"
                          >
                            Register As Customer
                          </button>
                        </Link>
                        <Link to="/Register/Supplier">
                          <button
                            className="btn btn-primary active mt-3"
                            type="button"
                          >
                            Register As Supplier
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-2 mb-2">
                  <p>Copyright 2025 | PSA Ameya | All Rights Reserved | <a className="text-danger" href="/downloads/PSA-India_Terms-of-Use_March-27-2025.pdf" download={true}>Terms of Use</a> | <a className="text-danger" href="/downloads/PSA-India_Privacy-Policy_March-27-2025.pdf" download={true}>Privacy Policy</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// HOC to inject navigate function
export default withNavigation(Login);